/* eslint-disable react/no-array-index-key */
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import Head from 'next/head';

import Script from 'next/script';
import ImmobileDetails from '@components/Pages/ImmobileDetails';
import Whatsapp from '@components/Whats';

import fetchImMobileCode from '@services/fetch-immobile-code';
import fetchImMobile from '@services/fetch-immobile';
import formatCurrency from '@helpers/formatCurrency';
import { useAppContexto } from 'contexts/AppContext';

export async function getServerSideProps({
  params,
  req
}: GetServerSidePropsContext): Promise<GetServerSidePropsResult<any>> {

  const { id } = params;


  try {
    const imovel = await fetchImMobileCode({
      props: { codImovel: id, empresaId: '' },
    });

    const auxTipoImovel = [];
    if (imovel?.tipoImovel?.id) {
      auxTipoImovel.push(imovel?.tipoImovel?.id);
    }

    const outrosImoveis = await fetchImMobile({
      props: { tiposImovelId: auxTipoImovel.length >= 1 ? auxTipoImovel : null },
    });

    return {
      props: {
        imovelDetalhe: imovel || null,
        confiraImoveis: outrosImoveis || null,
        host: req.headers.host
      },
    };
  } catch (error) {
    console.log('error init', error);

    if (error.message === '404') {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      };
    }
  }
}

type ImovelPageProps = {
  imovelDetalhe?: any;
  confiraImoveis?: any;
  host?: any;
};

export default function Immobile({
  imovelDetalhe,
  confiraImoveis,
  host
}: ImovelPageProps): JSX.Element {
  const { configuracoes, setConfiguracoes } = useAppContexto();

  const description = `${imovelDetalhe?.caracteristica?.caracteristicas}`;

  function renderPageTitle() {
    const tipoImovelDescricao = imovelDetalhe?.tipoImovel?.descricao || '';
    const quantidadeQuartos = imovelDetalhe?.caracteristica?.quantidadeQuartos;
    const finalidadeNome = imovelDetalhe?.tipoImovel?.finalidade?.nome || '';
    const operacaoImobiliaria = imovelDetalhe?.operacaoImobiliaria || 0;
    const areaTerreno = imovelDetalhe?.caracteristica?.areaTerreno || '';
    const areaTotalUniMedida =
      imovelDetalhe?.caracteristica?.areaTotalUniMedida?.descricao || '';
    const valorVenda = formatCurrency(imovelDetalhe?.valorVenda) || '';
    const bairroNome = imovelDetalhe?.logradouro?.bairro?.nome || '';
    const cidadeNome = imovelDetalhe?.logradouro?.bairro?.cidade?.nome || '';

    const comodos =
      quantidadeQuartos > 0
        ? quantidadeQuartos + (quantidadeQuartos > 1 ? ' quartos' : ' quarto')
        : '';

    const tipoImovelText =
      tipoImovelDescricao === 'Casa' && finalidadeNome === 'Comercial'
        ? tipoImovelDescricao
        : tipoImovelDescricao + (comodos ? ` com ${comodos}` : '');

    const operacaoText =
      operacaoImobiliaria === 1
        ? 'para alugar'
        : operacaoImobiliaria === 2
          ? 'à venda'
          : 'para alugar/venda';

    const areaText =
      quantidadeQuartos <= 0 && areaTerreno !== ''
        ? areaTerreno +
        (areaTotalUniMedida === 'm2' ? ' m²' : areaTotalUniMedida)
        : '';

    const titleParts = [
      tipoImovelText,
      operacaoText,
      areaText,
      valorVenda,
      bairroNome,
      cidadeNome,
    ];

    const pageTitle = titleParts.filter((part) => part !== '').join(' - ');

    // Final title
    return pageTitle;
  }

  let pageTitle = renderPageTitle();

  const hasDestaque = [];
  if (imovelDetalhe?.imagens?.length > 0) {
    imovelDetalhe.imagens.forEach((item) => {
      if (item.destaque) {
        hasDestaque.push(item);
      }
    });
  }

  const tagImage =
    imovelDetalhe?.imagemMini ||
    hasDestaque[0]?.arquivo ||
    (imovelDetalhe?.imagens && imovelDetalhe?.imagens[0]?.arquivo) ||
    'https://redelatitude.com.br/img/logo.png';

  const ddi = '55';
  const phoneNumber = String(ddi + imovelDetalhe?.empresa?.telefone || '')
    .replace(/\D/g, '');

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
        <title>{pageTitle}</title>
        <meta name="description" content={description} />

        <meta property="og:title" content={pageTitle} key="ogtitle" />
        <meta property="og:description" content={description} key="ogdesc" />

        <meta
          property="og:url"
          content={`https://${host}/imovel/${imovelDetalhe?.codImovel}`}
          key="ogurl"
        />
        <meta property="og:image" content={tagImage} key="ogimage" />
        <meta property="og:site_name" content={pageTitle} key="ogsitename" />
        <meta property="og:title" content={pageTitle} key="ogtitle" />
        <meta property="og:description" content={description} key="ogdesc" />
        <link
          rel="canonical"
          href={`https://${host}/imovel/${imovelDetalhe?.codImovel}`}
        />
      </Head>
      <ImmobileDetails props={imovelDetalhe} dataImoveis={confiraImoveis} />
      <Whatsapp
        phoneNumber={phoneNumber}
      />
      <Script src="/static/oitosimulator.min.js"></Script>
    </>
  );
}
